import React from 'react';
import home from 'images/home.svg';

export interface HomeIconProps {
  width?: string;
  height?: string;
  color?: string;
  isActivated?: boolean;
}

const HomeIcon: React.FC<HomeIconProps> = (props): JSX.Element => {
  return <img src={home} alt="home-icon" />;
};
export default HomeIcon;
